import MeHealthInvoiceDetailView from "issara-sdk/apis/MeHealthInvoiceDetailView_apps_MEH";

interface PaymentStatusData {
  status: "BILLED" | "PAID" | "CANCELED";
  [key: string]: any;
}

interface PaymentStatusCheckerOptions {
  initialInterval?: number;
  maxInterval?: number;
  // maxAttempts?: number;
  // timeout?: number;
  backoffMultiplier?: number;
  onComplete?: (data: PaymentStatusData) => void;
  onFailed?: (data: PaymentStatusData) => void;
  onPending?: (data: PaymentStatusData, attempts: number) => void;
  onError?: (error: unknown, attempts: number) => void;
  // onTimeout?: () => void;
  // onMaxAttempts?: () => void;
}

interface ResolvedOptions {
  initialInterval: number;
  maxInterval: number;
  // maxAttempts: number;
  // timeout: number;
  backoffMultiplier: number;
  onComplete?: (data: PaymentStatusData) => void;
  onFailed?: (data: PaymentStatusData) => void;
  onPending?: (data: PaymentStatusData, attempts: number) => void;
  onError?: (error: unknown, attempts: number) => void;
  // onTimeout?: () => void;
  // onMaxAttempts?: () => void;
}

export default class PaymentStatusChecker {
  private paymentId: string | number;
  private apiToken: string;
  private division: string;
  private options: ResolvedOptions;
  private attempts: number;
  private currentInterval: number;
  private startTime: number;
  private timerId: NodeJS.Timeout | number | null;

  constructor(paymentId: string | number, apiToken: string, division: string ,options: PaymentStatusCheckerOptions = {}) {
    this.paymentId = paymentId;
    this.apiToken = apiToken;
    this.division = division; 
    this.options = {
      initialInterval: options.initialInterval || 2000,
      maxInterval: options.maxInterval || 30000,
      // maxAttempts: options.maxAttempts || 50,
      // timeout: options.timeout || 5 * 60 * 1000, // 5 minutes
      backoffMultiplier: options.backoffMultiplier || 1,
      ...options
    };

    this.attempts = 0;
    this.currentInterval = this.options.initialInterval;
    this.startTime = Date.now();
    this.timerId = null;
  }

  async checkStatus(): Promise<PaymentStatusData> {
    try {

      let [res, err, network ] = await MeHealthInvoiceDetailView.retrieve({ 
        pk: this.paymentId,
        apiToken: this.apiToken,
        extra: { division: this.division || 0 },
      })
      // console.log('checkStatus network: ', network);
      // console.log('checkStatus err: ', err);
      // console.log('checkStatus res: ', res);
      // const response = await fetch(`/api/payment/status/${this.paymentId}`, {
      //   method: 'GET',
      //   headers: {
      //     'Content-Type': 'application/json',
      //   }
      // });

      if (!res) {
        throw new Error(`HTTP error! status: ${network.status}`);
      }

      return res
    } catch (error) {
      console.error('API call failed:', error);
      throw error;
    }
  }

  async poll(): Promise<void> {
    // Check if we've exceeded timeout
    // if (Date.now() - this.startTime > this.options.timeout) {
    //   this.stop();
    //   this.options.onTimeout?.();
    //   return;
    // }

    // Check if we've exceeded max attempts
    // if (this.attempts >= this.options.maxAttempts) {
    //   this.stop();
    //   this.options.onMaxAttempts?.();
    //   return;
    // }

    this.attempts++;

    try {
      const data = await this.checkStatus();

      if (data.status === 'PAID') {
        this.stop();
        this.options.onComplete?.(data);
      } else if (data.status === 'CANCELED') {
        this.stop();
        this.options.onFailed?.(data);
      } else {
        // Status is still pending, continue polling
        this.options.onPending?.(data, this.attempts);
        this.scheduleNext();
      }
    } catch (error) {
      this.options.onError?.(error, this.attempts);
      // Continue polling even on error
      this.scheduleNext();
    }
  }

  private scheduleNext(): void {
    // Exponential backoff
    this.currentInterval = Math.min(
      this.currentInterval * this.options.backoffMultiplier,
      this.options.maxInterval
    );

    this.timerId = setTimeout(() => this.poll(), this.currentInterval);
  }

  start(): this {
    this.poll();
    return this;
  }

  stop(): void {
    if (this.timerId) {
      clearTimeout(this.timerId as any);
      this.timerId = null;
    }
  }
}

export type { PaymentStatusData, PaymentStatusCheckerOptions };
